import { DatePicker, Input, MultipleSelect, Select, TagInput, Textarea } from '~components/generic/elements';
import { FieldSettings, FieldValue } from '~modules/media-library/model/RaiseRequestFormSettings';
import { IValueOptionsShape } from '~services/entity-definitions/interface';

type FieldGroupProps = {
  fieldSettings: FieldSettings;
  fieldValue: FieldValue;
  error?: string;
  onValueChanged?: (key: string, value: FieldValue) => void;
};

export function FieldGroup({ fieldSettings, fieldValue, onValueChanged, error }: FieldGroupProps) {
  const field = () => {
    switch (fieldSettings.type) {
      case 'textarea':
        return (
          <Textarea
            name={fieldSettings.name}
            value={fieldValue !== undefined ? String(fieldValue) : undefined}
            onChange={(value: string) => onValueChanged(fieldSettings.name, value)}
            disabled={fieldSettings.disabled}
            required={fieldSettings.required}
            className="form-control w-full"
          />
        );
      case 'select':
        return (
          <Select
            name={fieldSettings.name}
            value={fieldValue !== undefined ? String(fieldValue) : undefined}
            options={fieldSettings.options}
            onChange={(value: string | number) => onValueChanged(fieldSettings.name, value)}
            placeholder={'Please choose'}
            disabled={fieldSettings.disabled}
            required={fieldSettings.required}
          />
        );
      case 'multipleselect':
        return (
          <MultipleSelect
            name={fieldSettings.name}
            defaultValue={fieldValue}
            options={getMultipleSelectOptions(fieldSettings.options)}
            onChange={(value: string[] | number[]) => onValueChanged(fieldSettings.name, value as FieldValue)}
          />
        );
      case 'taginput':
        return (
          <TagInput
            name={fieldSettings.name}
            defaultValue={fieldValue}
            onChange={(value: string) => onValueChanged(fieldSettings.name, value)}
            disabled={fieldSettings.disabled}
            required={fieldSettings.required}
          />
        );
      case 'datepicker':
        return (
          <DatePicker
            name={fieldSettings.name}
            defaultValue={fieldValue !== undefined ? String(fieldValue) : undefined}
            onChange={(value: string) => onValueChanged(fieldSettings.name, value)}
            disabled={fieldSettings.disabled}
            required={fieldSettings.required}
            minDate={new Date()}
          />
        );

      default:
        return (
          <Input
            type="text"
            name={fieldSettings.name}
            value={fieldValue !== undefined ? String(fieldValue) : undefined}
            onChange={(value: string) => onValueChanged(fieldSettings.name, value)}
            disabled={fieldSettings.disabled}
            required={fieldSettings.required}
            className="form-control w-full"
          />
        );
    }
  };

  const errorMessage = () => {
    if (error !== null) {
      return <div className="error c-hint--error text-sm">{error}</div>;
    }
    return null;
  };

  // options for multipleselect is just simple object where keys are option-labels, values are option-values
  const getMultipleSelectOptions = (options?: Record<string, any>): IValueOptionsShape => {
    if (options) {
      return Object.keys(options).map(key => {
        return { label: options[key].value ?? key, value: options[key].id ?? options[key] };
      });
    }
    return [];
  };

  return (
    <div className="form-group">
      <div className="p42-label">
        <label>
          {fieldSettings.label}
          {Boolean(fieldSettings.required) && '*'}
        </label>
        {/*<div className="label-info">*/}
        {/*  <div className="tooltip-info">*/}
        {/*    <h3>{fieldSettings.label}</h3>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      {field()}
      {errorMessage()}{' '}
    </div>
  );
}
